/** 首页 Agent 下方图库 Tab */
export const HOME_GALLERY_TABS = [
  { id: 'ai-inspiration', label: 'AI灵感' },
  { id: 'material', label: '素材推荐' },
];

export const DEFAULT_HOME_GALLERY_TAB = HOME_GALLERY_TABS[0].id;

/** Admin 维护的官方图库分类，与首页 Tab 对应 */
export const OFFICIAL_MATERIAL_CATEGORIES = {
  'ai-inspiration': 'AI灵感',
  material: '素材推荐',
};

/** 首页图库 Tab 展示名 */
export const HOME_GALLERY_TAB_LABELS = {
  'ai-inspiration': 'AI灵感',
  material: '素材推荐',
};

/** Admin 官方图库页面配置 */
export const ADMIN_OFFICIAL_MATERIAL_PAGES = {
  'ai-inspiration': {
    category: OFFICIAL_MATERIAL_CATEGORIES['ai-inspiration'],
    title: 'AI灵感',
    description:
      '管理首页「AI灵感」图库。本地上传/API 入库进入「待发布」；用户从「素材推荐」选图经 AI 处理（图裂变、万能改图、扩图等）的产出也会进入待发布，且自动内嵌 IPE 水印。审核后手动发布，用户仅在「已发布」区可见。',
    emptyText: '暂无 AI 灵感素材，可上传或通过 API 入库',
    uploadLabel: '上传 AI 灵感',
    publishWorkflow: true,
  },
  'material-recommendation': {
    category: OFFICIAL_MATERIAL_CATEGORIES.material,
    title: '素材推荐',
    description:
      '管理首页「素材推荐」图库。插件采集与本地上传进入「待发布」，审核后手动发布；用户仅在「已发布」区可见。素材按入库日期（自然日）分组展示。',
    emptyText: '暂无素材，可上传或通过 API 入库',
    uploadLabel: '上传素材推荐',
    publishWorkflow: true,
  },
};

/** 官方图库 Admin 发布区（AI灵感 / 素材推荐） */
export const OFFICIAL_MATERIAL_PUBLISH_ZONES = {
  published: { id: 'published', label: '已发布' },
  pending: { id: 'pending', label: '待发布' },
};
